import { render, staticRenderFns } from "./ceshi.vue?vue&type=template&id=69e04bc4&scoped=true&"
import script from "./ceshi.vue?vue&type=script&lang=js&"
export * from "./ceshi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e04bc4",
  null
  
)

export default component.exports